import { Box, Button, Typography } from '@mui/material';
import { paidPlanOnBoardingTexts } from './AllTexts';
import { paidPlanOnBoardingSxs } from './OnBoardingCSS';
import { paths } from 'src/common/config/TextMessage';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router';
import { localStorageMethod } from 'src/common/config/FunctionHelper';

export const SqSpSiteSelectorComponent = ({ isLocalSeo = false }) => {
  const navigator = useNavigate();
  const isLocalSeoSqspFlow = localStorageMethod(
    'get',
    'is_local_seo_sqsp_flow'
  );
  return (
    <>
      {/* Connecting Squarespace site container  */}
      <Box sx={paidPlanOnBoardingSxs?.selectSiteBox(isLocalSeo)}>
        {/* Title for connecting to Squarespace site */}
        <Typography sx={paidPlanOnBoardingSxs?.selectSiteTitle}>
          {paidPlanOnBoardingTexts?.connectSqSpSite}
        </Typography>

        {/* Description for the connection process */}
        <Typography sx={paidPlanOnBoardingSxs?.selectSiteDescription}>
          {paidPlanOnBoardingTexts?.connectSqSpDesc}
        </Typography>

        {/* Box containing the avatar group module */}
        <Box sx={paidPlanOnBoardingSxs?.avatarBox}>
          {/* <AvatarGroupModule /> */}
        </Box>

        {/* Button to initiate connection to Squarespace */}
        <Box sx={paidPlanOnBoardingSxs?.connectButtonBox}>
          <Button
            onClick={() => {
              // Navigate to the Squarespace connection URL
              navigator(
                isLocalSeo
                  ? paths?.squareSpaceConnectUtmLocalSeo
                  : paths?.squareSpaceConnectOnBoarding
              );
            }}
            sx={paidPlanOnBoardingSxs?.connectButton}
            endIcon={<OpenInNewIcon />}
          >
            {/* Button text for connecting to Squarespace */}
            <Typography sx={paidPlanOnBoardingSxs?.connectBtnTextSx}>
              {paidPlanOnBoardingTexts?.connectSqSpBtn}
            </Typography>
          </Button>
        </Box>
      </Box>

      {/* Spacer box for layout */}
      <Box className="h-5"></Box>
    </>
  );
};
